import { render, staticRenderFns } from "./DebtPayment.vue?vue&type=template&id=bc077424&scoped=true"
import script from "./DebtPayment.vue?vue&type=script&lang=js"
export * from "./DebtPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc077424",
  null
  
)

export default component.exports